import * as React from "react"

function EspecialidadIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.51 15.5" {...props}>
      <defs>
        <style>{".cls-1{fill:#003da6}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className="cls-1"
            d="M14.21 13.32a.83.83 0 01-.82.81H2.21a.79.79 0 01-.77-.81V4.69a.78.78 0 01.77-.8h11.18a.82.82 0 01.82.8zM5.34 2.12a.85.85 0 01.83-.82h3.26a.82.82 0 01.81.82v.4h-4.9zm8.05.4h-1.78v-.4A2.13 2.13 0 009.43 0H6.17A2.15 2.15 0 004 2.12v.4H2.21A2.2 2.2 0 000 4.69v8.63a2.2 2.2 0 002.21 2.18h11.18a2.12 2.12 0 002.12-2.18V4.69a2.12 2.12 0 00-2.12-2.17"
          />
          <path
            className="cls-1"
            d="M9.09 5.12L6.42 5.12 6.42 7.72 3.97 7.72 3.97 10.31 6.42 10.31 6.42 12.77 9.09 12.77 9.09 10.31 11.61 10.31 11.61 7.72 9.09 7.72 9.09 5.12z"
          />
        </g>
      </g>
    </svg>
  )
}

export default EspecialidadIcon
